import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3RemoteOnOffSettings } from 'ngx-modbus';

export const REMOTE_ON_OFF_FORM: LeanFormSchema = {
  version: '1',
  id: 'remote-on-off',
  name: 'Remote On/Off Control',
  sections: [{
    id: 'remote-on-off',
    labelKey: 'remoteOnOffControl',
    registerTable: 'V3RemoteOnOffSettings',
    validityMask: 'AddressMask_Config_Remote1',
    fields: [
      fieldRef(V3RemoteOnOffSettings, 'Remote_On_Off_Control'),
    ],
  }],
};
